// extracted by mini-css-extract-plugin
export default {"first-card-border":"CardGroup_first-card-border__xH9M1","last-card-border":"CardGroup_last-card-border__h1yuQ","middle-card-border":"CardGroup_middle-card-border__AhSfD"};